import React from "react";
import classNames from "classnames";
import { MdCancel } from "react-icons/md";

const inputClass =
  "appearance-none block w-full font-display border border-gray-400 rounded py-3 px-4 mb-3 leading-tight focus:outline-none bg-white focus:border-gray-500";
const inputErrorClass = "border border-red-500 b-2 text-red-500";

const labelClass =
  "block tracking-wide text-black font-display text-sm leading-5 font-medium mb-2";

const AdditionalService = ({ register, index, remove, item, errors }) => {
  const handleRemove = (event) => {
    remove(index);
  };

  return (
    <div>
      <input
        ref={register()}
        name={`additionalServices[${index}].id`}
        defaultValue={item.id}
        type="hidden"
      />
      <div className="flex items-center">
        <div className="md:w-1/2 w-full mb-6 ">
          <label className={labelClass} htmlFor="name">
            Product
          </label>
          <input
            className={classNames({
              [inputClass]: true,
              [inputErrorClass]:
                errors?.additionalServices?.[index]?.name?.message,
            })}
            // id="product"
            name={`additionalServices[${index}].name`}
            readOnly
            ref={register()}
            defaultValue={item.name}
          />
        </div>
        <div className="ml-4 mb-2">
          <button type="button" onClick={handleRemove}>
            <MdCancel size={24} color="black" />
          </button>
        </div>
      </div>
      <div className="md:flex">
        <div className="md:w-1/2 w-full mb-6">
          <label className={labelClass} htmlFor="rate">
            Price / Unit
          </label>
          <input
            className={classNames({
              [inputClass]: true,
              [inputErrorClass]:
                errors?.additionalServices?.[index]?.rate?.message,
            })}
            // id="price"
            placeholder="Price"
            name={`additionalServices[${index}].rate`}
            ref={register()}
            defaultValue={item.rate}
            // required
          />
        </div>
        <div className="md:w-1/2 w-full mb-6 md:ml-6">
          <label className={labelClass} htmlFor="quantity">
            No of Units
          </label>
          <input
            className={classNames({
              [inputClass]: true,
              [inputErrorClass]:
                errors?.additionalServices?.[index]?.quantity?.message,
            })}
            // id="quantity"
            placeholder="No of Units"
            name={`additionalServices[${index}].quantity`}
            ref={register()}
            defaultValue={item.quantity}
            // required
          />
        </div>
      </div>
      <div className="md:flex">
        <div className="md:w-1/2 w-full mb-6">
          <label className={labelClass} htmlFor="startDate">
            Service Start Date
          </label>
          <input
            className={classNames({
              [inputClass]: true,
              [inputErrorClass]:
                errors?.additionalServices?.[index]?.startDate?.message,
            })}
            // id="startDate"
            placeholder="Start Date"
            type="date"
            name={`additionalServices[${index}].startDate`}
            defaultValue={item.startDate}
            ref={register()}
            // required
          />
        </div>
        <div className="md:w-1/2 w-full mb-6 md:ml-6">
          <label className={labelClass} htmlFor="duration">
            Service End Date
          </label>
          <input
            className={classNames({
              [inputClass]: true,
              [inputErrorClass]:
                errors?.additionalServices?.[index]?.endDate?.message,
            })}
            // id="duration"
            placeholder="End Date"
            type="date"
            name={`additionalServices[${index}].endDate`}
            defaultValue={item.endDate}
            ref={register()}
            // required
          />
        </div>
      </div>
    </div>
  );
};

export default AdditionalService;
